/*LIBRARY*/
import { connect } from "react-redux";
import { useState, useCallback, useMemo } from "react";
import bbox from "@turf/bbox";

/*COMPONENT*/
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  edit_side_table_object,
  reset_geojson_filtered,
  show_all_geojson_filtered,
} from "../../App/actions/propertiesActions";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_sini } from "../../App/actions/sini_v2";
import {
  set_value_genangan,
  genangan_update,
} from "../../App/actions/genangan_actions";

/*PICTURE*/
import icon_compact_table from "../../Assets/svg/icon_compact_table.svg";
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SIDE_TABLE = ({
  //variable
  auth,
  layer,
  loading_reducer,
  genangan_reducer,

  //function
  edit_side_table_object,
  set_value_sini,
  set_value_layer,
  set_value_genangan,
  set_value_properties,
  reset_geojson_filtered,
  show_all_geojson_filtered,
  genangan_update,
}) => {
  const [state, setState] = useState({
    list_state_jsx: null,
    modal_image: false,
    src_image: "",
    modal_edit_field: false,
    side_table_state: {},
    fields: [],
    fields_image: [],
    fields_non_image: [],
    src_image_array: [],
    image_index: 0,
  });

  //local storage
  const language = localStorage?.language || auth?.language;

  //local state
  const {
    side_table_state,
    src_image_array,
    image_index,
    modal_image,
    modal_edit_field,
  } = state;

  //global props
  const domain = auth.domain;
  const { loading_item_array } = loading_reducer;
  const { layer_id, geo_layer_list, feature_key_selected } = layer;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let polygon_key_active_array =
    genangan_reducer?.polygon_key_active_array || [];
  const visibility_flood = genangan_reducer.visibility_flood;

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;

  const features = geo_layer?.geojson_filtered?.features || [];
  const features_all = geo_layer?.geojson?.features || [];
  const features_all_length = features_all?.length;

  const fields = geo_layer?.fields || [];
  const side_table_object = useMemo(() => {
    return geo_layer?.side_table_object || {};
  }, [geo_layer?.side_table_object]);
  const {
    type_2,
    image_fields: img_field_keys = [],
    shown_fields: shown_field_keys = [],
    is_show_all,
    sorted_number,
  } = side_table_object;
  const image_fields = fields.filter((item) =>
    img_field_keys.includes(item?.key)
  );
  const shown_fields = fields.filter((item) =>
    shown_field_keys.includes(item?.key)
  );
  const images_length = image_fields?.length || 0;

  //functions
  const on_next = useCallback(() => {
    setState((prev) => ({
      ...prev,
      image_index: (image_index + 1) % images_length,
    }));
  }, [image_index, images_length]);

  const on_prev = useCallback(() => {
    setState((prev) => ({
      ...prev,
      image_index: image_index === 0 ? images_length - 1 : image_index - 1,
    }));
  }, [image_index, images_length]);

  const on_click_array = (event) => {
    const name = event.currentTarget.dataset.name;
    const value = event.currentTarget.dataset.value;
    const array = side_table_state?.[name] || [];
    const new_array = array.includes(value)
      ? array.filter((item) => item !== value)
      : [...array, value];
    setState((prev) => ({
      ...prev,
      side_table_state: {
        ...prev.side_table_state,
        [name]: new_array,
      },
    }));
  };

  const on_fly = useCallback(
    (feature) => {
      set_value_sini({
        key: "feature_key_fly_genangan",
        value: feature.key,
      });
      set_value_layer({
        key: "feature_key_selected",
        value: feature.key,
      });
      set_value_layer({
        key: "feature_object_selected",
        value: feature,
      });
      set_value_genangan({
        key: "feature_object_selected_genangan",
        value: feature,
      });
      const { map_object } = layer;
      const geojson = { type: "FeatureCollection", features: [feature] };
      let [minLng, minLat, maxLng, maxLat] = bbox(geojson);
      if (map_object) {
        map_object.fitBounds(
          [
            [minLng, minLat],
            [maxLng, maxLat],
          ],
          {
            padding: layer.padding_fly,
            maxZoom: layer.max_zoom,
            duration: 750,
          }
        );
      }
    },
    [layer, set_value_sini, set_value_layer, set_value_genangan]
  );

  const on_get_genangan = useCallback(
    (feature) => {
      on_fly(feature);
      set_value_properties({
        key: "modal_flood_new",
        value: true,
      });
      set_value_genangan({
        key: "geojson_flood_in_progress",
        value: {
          type: "FeatureCollection",
          features: [],
        },
      });
      set_value_genangan({
        key: "current_dem",
        value: 0,
      });
      set_value_genangan({
        key: "current_calc",
        value: 0,
      });
      set_value_genangan({
        key: "visibility_flood",
        value: "visible",
      });
    },
    [on_fly, set_value_properties, set_value_genangan]
  );

  const on_toggle_genangan = useCallback(
    (feature_key) => {
      if (polygon_key_active_array.includes(feature_key)) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        polygon_key_active_array = polygon_key_active_array.filter(
          (item) => item !== feature_key
        );
      } else {
        polygon_key_active_array.push(feature_key);
      }
      set_value_genangan({
        key: "polygon_key_active_array",
        value: polygon_key_active_array,
      });
      set_value_genangan({
        key: "visibility_flood",
        value: "visible",
      });
      genangan_update();
    },
    [polygon_key_active_array]
  );

  const toggle_modal_image = useCallback(
    (feature) => {
      const src_image_array = side_table_object?.image_fields.map((item) => {
        return feature?.properties?.[item];
      });
      setState((prev) => ({
        ...prev,
        modal_image: !prev.modal_image,
        src_image_array,
        image_index: 0,
      }));
    },
    [side_table_object]
  );

  const toggle_edit_field = useCallback(() => {
    const fields = geo_layer?.fields || [];
    const fields_image = fields.filter((item) => item.type === "image");
    const fields_not_image = fields.filter((item) => item.type !== "image");
    setState((prev) => ({
      ...prev,
      modal_edit_field: !prev.modal_edit_field,
      side_table_state: geo_layer?.side_table_object || {},
      fields: geo_layer?.fields || [],
      fields_image,
      fields_not_image,
    }));
  }, [geo_layer]);

  const on_change = useCallback((event) => {
    const { name, value } = event.target;
    setState((prev) => ({
      ...prev,
      side_table_state: {
        ...prev.side_table_state,
        [name]: value,
      },
    }));
  }, []);

  const on_save_edit = useCallback(() => {
    setState((prev) => ({
      ...prev,
      modal_edit_field: false,
    }));
    edit_side_table_object({
      layer_id: layer.layer_id,
      side_table_object: state.side_table_state,
    });
  }, [layer.layer_id, state.side_table_state, edit_side_table_object]);

  const on_init_side_table = useCallback(() => {
    const fields = geo_layer?.fields || [];
    const image_fields = fields
      .filter((item) => item.type === "image")
      .map((item) => item.key);
    const shown_fields = fields
      .filter((item) => item.type !== "image" && !item.isStyle)
      .map((item) => item.key)
      .slice(0, 5);
    const side_table_object = {
      type_2: "basic",
      flood_field: "",
      sorted_field: "",
      sorted_mode: "des",
      is_show_all: "", //kosong = yes, tidak usah slice
      sorted_number: 10,
      image_fields,
      shown_fields,
    };
    edit_side_table_object({
      layer_id: layer.layer_id,
      side_table_object,
    });
  }, [geo_layer, layer.layer_id, edit_side_table_object]);

  //render
  return (
    <main>
      {modal_image && (
        <Modal
          modalSize="medium"
          id="modal_image"
          isOpen={state.modal_image}
          onClose={toggle_modal_image}
        >
          <div className="box-body">
            <section style={{ position: "relative", textAlign: "center" }}>
              <section className="two_container_flex margin_bottom">
                <span className="badge_small yellow_container">
                  #{image_index + 1}
                </span>
                <span className="text_right">
                  <div
                    className="badge_small background_white outline_black margin_left"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {image_fields?.[image_index]?.name}
                  </div>
                </span>
              </section>
              {src_image_array?.[image_index] ? (
                <img
                  src={src_image_array[image_index]}
                  alt={src_image_array[image_index]}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "calc( 100vh - 150px - 60px )",
                    width: "auto",
                    height: "auto",
                  }}
                />
              ) : (
                <div
                  style={{
                    height: "calc( 100vh - 150px - 60px )",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f0f0f0",
                  }}
                >
                  {dict?.["Photo not uploaded"]?.[language]}
                </div>
              )}
              <button
                onClick={on_prev}
                className="button_circle button_white outline_black"
                style={{
                  position: "absolute",
                  left: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                &lt;
              </button>
              <button
                onClick={on_next}
                className="button_circle button_white outline_black"
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                &gt;
              </button>
            </section>
          </div>
        </Modal>
      )}

      {modal_edit_field && (
        <Modal
          modalSize="small"
          id="modal_edit_field"
          isOpen={state.modal_edit_field}
          onClose={toggle_edit_field}
        >
          <div className="box-body">
            <p className="text_bold margin_bottom">
              {dict?.["Edit the displayed columns"]?.[language]}
            </p>
            {[
              "localhost:3003",
              "dsdajakarta.mapid.io",
              "dsdajakarta-alpha.mapid.io",
              "dsdajakarta-beta.mapid.io",
              "kabalai.mapid.io",
              "bbwsciliwungcisadane.mapid.io",
              "cilicis-alpha.mapid.io",
              "cilicis-beta.mapid.io",
            ].includes(domain) && (
              <>
                <section className="margin_bottom">
                  <p className="text_medium sub_color margin_bottom">
                    {dict?.["Flood inundation algorithm options"]?.[language]}
                  </p>
                  <select
                    value={state?.side_table_state.type_2}
                    name="type_2"
                    onChange={on_change}
                  >
                    <option value="">
                      {dict?.["Basic (does not use algorithms)"]?.[language]}
                    </option>
                    <option value="banjir">
                      {dict?.["Use the flood algorithm"]?.[language]}
                    </option>
                  </select>
                  {state.side_table_state.type_2 === "banjir" && (
                    <>
                      <section className="margin_bottom">
                        <p className="text_medium sub_color margin_bottom">
                          {dict?.["Flood level column in cm"]?.[language]}
                        </p>
                        <select
                          value={state.side_table_state.flood_level_field}
                          name="flood_level_field"
                          onChange={on_change}
                        >
                          <option value="">
                            {dict?.["Select Column"]?.[language]}
                          </option>
                          {state.fields.map((field) => (
                            <option key={field.key} value={field.key}>
                              {field.name}
                            </option>
                          ))}
                        </select>
                      </section>

                      <section className="margin_bottom">
                        <p className="text_medium sub_color margin_bottom">
                          {
                            dict?.[
                              "The results column for the area of inundation (square meters)"
                            ]?.[language]
                          }
                        </p>
                        <select
                          value={state.side_table_state.flood_result_area_field}
                          name="flood_result_area_field"
                          onChange={on_change}
                        >
                          <option value="">
                            {dict?.["Select Column"]?.[language]}
                          </option>
                          {state.fields.map((field) => (
                            <option key={field.key} value={field.key}>
                              {field.name}
                            </option>
                          ))}
                        </select>
                      </section>
                    </>
                  )}
                </section>
              </>
            )}

            <section className="margin_bottom">
              <p className="text_medium sub_color margin_bottom">
                {dict?.["Columns to sort"]?.[language]}
              </p>
              <select
                value={state?.side_table_state?.sorted_field}
                name="sorted_field"
                onChange={on_change}
              >
                <option value="">Pilih kolom</option>
                {state.fields.map((field) => (
                  <option key={field.key} value={field.key}>
                    {field.name}
                  </option>
                ))}
              </select>
            </section>

            <section className="margin_bottom">
              <p className="text_medium sub_color margin_bottom">
                {dict?.["Sorting mode"]?.[language]}
              </p>
              <select
                value={state.side_table_state.sorted_mode}
                name="sorted_mode"
                onChange={on_change}
              >
                <option value="des">
                  {
                    dict?.["Descending order (from largest or newest)"]?.[
                      language
                    ]
                  }
                </option>
                <option value="asc">
                  {
                    dict?.["Ascending order (from the smallest or earliest)"]?.[
                      language
                    ]
                  }
                </option>
              </select>
            </section>

            <section className="margin_bottom">
              <p className="text_medium sub_color margin_bottom">
                {
                  dict?.["Option to show some initial data when loading"]?.[
                    language
                  ]
                }
              </p>
              <select
                value={state?.side_table_state?.is_show_all}
                name="is_show_all"
                onChange={on_change}
              >
                <option value="">
                  {dict?.["No, directly display all data"]?.[language]}
                </option>
                <option value="no">
                  {
                    dict?.["Yes, just show some data at the beginning"]?.[
                      language
                    ]
                  }
                </option>
              </select>
            </section>

            {state.side_table_state.is_show_all === "no" && (
              <section className="margin_bottom">
                <p className="text_medium sub_color margin_bottom">
                  {dict?.["The amount of data displayed first"]?.[language]}
                </p>
                <input
                  value={state.side_table_state.sorted_number}
                  name="sorted_number"
                  onChange={on_change}
                  type="number"
                />
              </section>
            )}

            <section className="margin_bottom">
              <p className="text_medium sub_color margin_bottom">
                {dict?.["The image column displayed"]?.[language]}
              </p>
              <div
                className="container background_white outline_grey"
                style={{ maxHeight: "211px", overflowY: "auto" }}
              >
                {state?.fields_image?.map((field, idx) => {
                  const className =
                    state.side_table_state?.image_fields?.includes(field?.key)
                      ? "checklist_active"
                      : "checklist_not";
                  return (
                    <div
                      key={idx}
                      className="two_container_flex margin_bottom cursor_pointer"
                      data-name="image_fields"
                      data-value={field?.key}
                      onClick={on_click_array}
                    >
                      <span className={className} />
                      <p className="text_medium sub_color">{field.name}</p>
                    </div>
                  );
                })}
              </div>
            </section>

            <section className="margin_bottom">
              <p className="text_medium sub_color margin_bottom">
                {dict?.["Table columns displayed"]?.[language]}
              </p>
              <div
                className="container background_white outline_grey"
                style={{ maxHeight: "211px", overflowY: "auto" }}
              >
                {state?.fields_not_image?.map((field, idx) => {
                  const className =
                    state.side_table_state?.shown_fields?.includes(field?.key)
                      ? "checklist_active"
                      : "checklist_not";
                  return (
                    <div
                      key={idx}
                      className="two_container_flex margin_bottom cursor_pointer"
                      data-name="shown_fields"
                      data-value={field?.key}
                      onClick={on_click_array}
                    >
                      <span className={className} />
                      <p className="text_medium sub_color">{field.name}</p>
                    </div>
                  );
                })}
              </div>
            </section>
            <br />
            <section className="text_center">
              <button
                className="button_big background_black"
                onClick={on_save_edit}
              >
                {dict?.["Save"]?.[language]}
              </button>
            </section>
          </div>
        </Modal>
      )}

      {type_2 !== undefined ? (
        <div>
          <div className="container background_grey_light margin_bottom">
            <section className="two_container_flex margin_bottom">
              <div className="badge_small background_white">
                {dict?.["Compact List"]?.[language]}
              </div>
              <div className="text_right">
                <button
                  className="button_small background_black"
                  onClick={toggle_edit_field}
                >
                  Edit
                </button>
              </div>
            </section>

            {features.length === features_all_length && is_show_all === "no" ? (
              <button
                className="button background_black"
                onClick={reset_geojson_filtered}
              >
                {dict?.["Display the first"]?.[language]} {sorted_number}{" "}
                {dict?.["of data"]?.[language]}
              </button>
            ) : (
              <button
                className="button background_black"
                onClick={show_all_geojson_filtered}
              >
                {dict?.["Show All Data"]?.[language]}
              </button>
            )}

            {type_2 === "banjir" && (
              <section>
                {visibility_flood === "visible" ? (
                  <div
                    className="button background_black margin_top"
                    onClick={() => {
                      set_value_genangan({
                        key: "visibility_flood",
                        value: "none",
                      });
                      set_value_genangan({
                        key: "polygon_key_active_array",
                        value: [],
                      });
                    }}
                  >
                    Hide semua banjir
                  </div>
                ) : (
                  <div
                    className="button background_black margin_top"
                    onClick={() => {
                      set_value_genangan({
                        key: "visibility_flood",
                        value: "visible",
                      });
                      const polygon_key_active_array = features.map((item) => {
                        return item?.key;
                      });
                      set_value_genangan({
                        key: "polygon_key_active_array",
                        value: polygon_key_active_array,
                      });
                    }}
                  >
                    Tampilkan semua banjir
                  </div>
                )}
              </section>
            )}
          </div>
          {features.map((feature, idx) => {
            const { years_count, months_count, days_count } = feature;

            const has_image = image_fields.length > 0;

            const text_container = (
              <>
                {!has_image && (
                  <button
                    className="button background_white margin_bottom"
                    onClick={() => on_fly(feature)}
                  >
                    {dict?.["Fly to"]?.[language]}
                  </button>
                )}
                <section
                  className="container background_white"
                  style={{
                    borderRadius: "5px",
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {shown_fields.map((field) => (
                    <div key={field.key} className="margin_bottom">
                      <p className="text_small sub_color">{field?.name}</p>
                      <p className="text_medium">
                        {feature?.properties?.[field?.key] || "-"}
                      </p>
                    </div>
                  ))}
                </section>
              </>
            );

            const final_container = has_image ? (
              <div className="two_container_flex">
                <section>
                  <div
                    className="margin_bottom"
                    style={{
                      width: "99px",
                      height: "67px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      backgroundImage: `url(${
                        feature?.properties?.[image_fields[0].key]
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                    onClick={() => toggle_modal_image(feature)}
                  />
                  {type_2 === "banjir" ? (
                    <>
                      <button
                        className="button background_white margin_top"
                        onClick={() => on_get_genangan(feature)}
                      >
                        Algoritma
                      </button>
                      <br />
                      <button
                        className={`button background_white margin_top ${
                          polygon_key_active_array.includes(feature.key)
                            ? "background_black"
                            : "background_white"
                        }`}
                        onClick={() => on_toggle_genangan(feature?.key)}
                      >
                        <ICON_VIEW
                          color={
                            polygon_key_active_array.includes(feature.key)
                              ? "#fff"
                              : "#000"
                          }
                          strokeWidth={4}
                          style={{ width: "19px", height: "19px" }}
                        />
                      </button>
                    </>
                  ) : (
                    <button
                      className="button background_white"
                      onClick={() => on_fly(feature)}
                    >
                      {dict?.["Fly to"]?.[language]}
                    </button>
                  )}
                </section>
                {text_container}
              </div>
            ) : (
              text_container
            );
            const is_future =
              days_count < 0 || months_count < 0 || years_count < 0;
            return (
              <main
                className={`container margin_bottom background_grey_light ${
                  feature_key_selected === feature?.key
                    ? "outline_black"
                    : "outline_white"
                }`}
                key={idx}
              >
                <section className="two_container_flex margin_bottom">
                  <div
                    className={`badge_small ${
                      feature_key_selected === feature?.key
                        ? "background_black"
                        : "yellow_container"
                    }`}
                  >
                    #{idx + 1}
                  </div>

                  <div className="text_right">
                    {years_count === 0 &&
                    months_count === 0 &&
                    days_count === 0 ? (
                      <div className="badge_small background_white margin_left">
                        {dict?.["Today"]?.[language]}
                      </div>
                    ) : (
                      <div className="badge_small background_white margin_left">
                        {Math.abs(years_count) > 0 && (
                          <>
                            {Math.abs(years_count)}{" "}
                            {dict?.["years"]?.[language]}{" "}
                          </>
                        )}
                        {Math.abs(months_count) > 0 && (
                          <>
                            {Math.abs(months_count)}{" "}
                            {dict?.["months"]?.[language]}{" "}
                          </>
                        )}
                        {Math.abs(days_count) > 0 && (
                          <>
                            {Math.abs(days_count)} {dict?.["days"]?.[language]}{" "}
                          </>
                        )}
                        {is_future
                          ? dict?.["left"]?.[language]
                          : dict?.["ago"]?.[language]}
                      </div>
                    )}
                  </div>
                </section>
                {final_container}
              </main>
            );
          })}
          <section className="text_center margin_top">
            <button
              className="button background_black"
              onClick={show_all_geojson_filtered}
            >
              {dict?.["Show All Data"]?.[language]}
            </button>
          </section>
        </div>
      ) : (
        <section className="container background_grey_light text_center">
          <img
            className="margin_bottom_extra"
            alt="Compact Table"
            width={65}
            src={icon_compact_table}
          />
          <br />
          {loading_item_array.includes("edit_side_table_object") ? (
            <button className="button_big background_grey">
              {dict?.["Perform automatic setup"]?.[language]}
            </button>
          ) : (
            <button
              className="button_big background_black"
              onClick={on_init_side_table}
            >
              {dict?.["Initialize Compact List"]?.[language]}
            </button>
          )}
        </section>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  loading_reducer: state.loading_reducer,
  genangan_reducer: state.genangan_reducer,
});

export default connect(mapStateToProps, {
  edit_side_table_object,
  set_value_properties,
  set_value_layer,
  set_value_sini,
  set_value_genangan,
  reset_geojson_filtered,
  show_all_geojson_filtered,
  genangan_update,
})(SIDE_TABLE);
